import style from './Overlay.module.scss';
import cc from 'classcat';
import { connect } from 'react-redux';

type OverlayProps = {
  show: boolean;
};

const Overlay = ({ show }: OverlayProps) => (
  <div className={cc({ [style.overlay]: true, [style.shown]: show })}>
    <p>Loading</p>
  </div>
);

function mapStateToProps({ OverlayReducer }: any) {
  const { show } = OverlayReducer;
  return { show };
}

export default connect(mapStateToProps)(Overlay);
